<div class="field pb-3">
  <label class="weight-medium is-uppercase">{{ label }}</label>

  <div class="control"
   [class.is-danger]="(submitted && !date) || error ||
   selectedDate < this.minDate || selectedDate > this.maxDate"
   [class.disabled]="disabled" [class.none-events]="disabled">
    <div [id]="id" data-icons.date="">
      <input type="date" class="input is-danger" />
    </div>
  </div>
  <p *ngIf="(submitted && !date) || selectedDate < this.minDate ||
  selectedDate > this.maxDate" class="help is-danger">
    {{ 'errors.invalid-date-input' | translate }}
  </p>
  <p *ngIf="error" class="help is-danger">
    {{ errorMessage }}
  </p>
</div>
